/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Validation_Email_InvalidInputs */

const en_users_validation_email_invalid = /** @type {(inputs: Users_Validation_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid email address`)
};

const pt_br2_users_validation_email_invalid = /** @type {(inputs: Users_Validation_Email_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endereço de e-mail inválido`)
};

/**
* | output |
* | --- |
* | "Invalid email address" |
*
* @param {Users_Validation_Email_InvalidInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_validation_email_invalid = /** @type {((inputs?: Users_Validation_Email_InvalidInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Validation_Email_InvalidInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_validation_email_invalid(inputs)
	return pt_br2_users_validation_email_invalid(inputs)
});